define.alias("shared/components/shared/credentials/basic-display-status/upgrade", "media/components/shared/credentials/basic-display-status/upgrade");